// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__1dBPG","contentStyles":"styles_contentStyles__irT_S","image":"styles_image__3Hshf"};